<template>
    <div class="modal fade" id="modalAjoutCritere" tabindex="-1" role="dialog" aria-labelledby="modalAjoutCritereLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="modalAjoutCritereLabel">Ajouter le critère : {{ critere.nom }}</h4>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitForm">
                        <div class="form-group">
                            <label>Date de début</label>
                            <input type="date" 
                                   class="form-control" 
                                   v-model="critereClub.date_debut" 
                                   @change="updateDateFinMin"
                                   required>
                        </div>
                        <div class="form-group">
                            <label>Date de fin</label>
                            <input type="date" 
                                   class="form-control" 
                                   v-model="critereClub.date_fin" 
                                   :min="dateFinMin"
                                   :disabled="!critereClub.date_debut"
                                   required>
                            <small v-if="critereClub.date_fin && !isDateFinValide" class="text-danger">
                                La date de fin doit être postérieure à la date de début
                            </small>
                        </div>
                        <div class="form-group">
                            <label>Commentaire <small class="text-muted">(optionnel)</small></label>
                            <textarea class="form-control" 
                                      v-model="critereClub.commentaire" 
                                      rows="3"
                                      placeholder="Ajoutez un commentaire si nécessaire"></textarea>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
                    <button type="button" 
                            class="btn btn-primary" 
                            @click="submitForm" 
                            :disabled="loading || !isFormValide">
                        <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                        Ajouter
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'ModalAjoutCritere',
    props: {
        clubId: {
            type: [String, Number],
            required: true
        },
        critere: {
            type: Object,
            required: true
        }
    },
    data() {
        const currentYear = new Date().getFullYear();
        const dateDebut = new Date(Date.UTC(currentYear, 4, 1)); // 1er mai de l'année en cours
        const dateFin = new Date(Date.UTC(currentYear + 1, 4, 1)); // 1er mai de l'année suivante

        return {
            loading: false,
            critereClub: {
                critere_id: this.critere.id,
                date_debut: this.formatDateForInput(dateDebut),
                date_fin: this.formatDateForInput(dateFin),
                club_id: this.clubId,
                commentaire: ''
            },
            dateFinMin: this.formatDateForInput(dateDebut)
        }
    },
    computed: {
        ...mapGetters({
            getRoute: 'getRoute',
        }),
        isDateFinValide() {
            if (!this.critereClub.date_debut || !this.critereClub.date_fin) {
                return true;
            }
            return new Date(this.critereClub.date_fin) >= new Date(this.critereClub.date_debut);
        },
        isFormValide() {
            return this.critereClub.date_debut && 
                   this.critereClub.date_fin && 
                   this.isDateFinValide;
        }
    },
    methods: {
        formatDateForInput(date) {
            return date.toISOString().split('T')[0];
        },
        updateDateFinMin() {
            if (this.critereClub.date_debut) {
                const dateDebut = new Date(this.critereClub.date_debut);
                const dateFin = new Date(dateDebut);
                dateFin.setFullYear(dateFin.getFullYear() + 2);
                
                this.dateFinMin = this.formatDateForInput(dateDebut);
                this.critereClub.date_fin = this.formatDateForInput(dateFin);
            } else {
                this.dateFinMin = '';
                this.critereClub.date_fin = '';
            }
        },
        submitForm() {
            if (!this.isFormValide) {
                return;
            }

            let self = this;
            self.loading = true;
            
            this.$http.post(this.getRoute('Labelisation.addCritereClub'), this.critereClub)
                .then(response => {
                    self.loading = false;
                    $('#modalAjoutCritere').modal('hide');
                    self.$emit('critere-ajoute');
                    // Réinitialiser le formulaire avec les dates par défaut
                    const currentYear = new Date().getFullYear();
                    const dateDebut = new Date(Date.UTC(currentYear, 4, 1)); // 1er mai de l'année en cours
                    const dateFin = new Date(Date.UTC(currentYear + 1, 4, 1)); // 1er mai de l'année suivante
                    
                    self.critereClub = {
                        critere_id: this.critere.id,
                        date_debut: this.formatDateForInput(dateDebut),
                        date_fin: this.formatDateForInput(dateFin),
                        club_id: this.clubId,
                        commentaire: ''
                    };
                    self.dateFinMin = self.critereClub.date_debut;
                })
                .catch(error => {
                    self.loading = false;
                    console.error('Erreur lors de l\'ajout du critère:', error);
                });
        }
    }
}
</script> 


// WEBPACK FOOTER //
// src/components/Secretariat/Club/ModalAjoutCritere.vue